import { cartData } from 'data/mock-data';

const mock = () => ({
  data: { cartData },
});

export default mock;
